import { ReactElement, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { message } from 'antd';
import RecordingOverview from './recording-overview/RecordingOverview';
import Transcription from './transcription/Transcription';
import { ContentBlock, TwoColumnLayout } from './Content.style';
import useRecordingDetail from '../hooks/useRecordingDetail';
import { getDisplayPhones } from '../utils/getDisplayPhones';

const Content = (): ReactElement => {
  const { id } = useParams<{ id: string }>();
  const recordingId = Number(id);
  const [messageApi, contextHolder] = message.useMessage();
  const { recording, advisors, customers, updateSummary, updateRecording } = useRecordingDetail(
    recordingId,
    messageApi
  );

  const displayPhones = useMemo(
    () =>
      getDisplayPhones({
        advisor: recording.advisor,
        customer: recording.customer,
        originalFrom: recording.originalFrom,
        originalTo: recording.originalTo,
      }),
    [recording.advisor, recording.customer, recording.originalFrom, recording.originalTo]
  );

  return (
    <ContentBlock>
      {contextHolder}
      <TwoColumnLayout>
        <RecordingOverview
          recordingId={recordingId}
          title={recording.title}
          advisor={recording.advisor}
          customer={recording.customer}
          meetingDateTime={recording.meetingDateTime}
          advisors={advisors}
          customers={customers}
          advisorPhone={displayPhones.advisorPhone}
          customerPhone={displayPhones.customerPhone}
          originalFrom={recording.originalFrom}
          originalTo={recording.originalTo}
          duration={recording.duration}
          registeredAt={recording.registeredAt}
          presignedUrl={recording.presignedUrl}
          summaryText={recording.summaryText}
          recordingStatusId={recording.recordingStatusId}
          onUpdateRecording={updateRecording}
          onUpdateSummary={updateSummary}
        />
        <Transcription
          fullText={recording.fullText}
          recordingStatusId={recording.recordingStatusId}
          title={recording.title}
          advisorName={recording.advisor?.name ?? null}
          customerName={recording.customer?.name ?? null}
          advisorPhone={displayPhones.advisorPhone}
          customerPhone={displayPhones.customerPhone}
        />
      </TwoColumnLayout>
    </ContentBlock>
  );
};

export default Content;
